import { ReactElement } from "react";
import { Link } from "react-router-dom";
import { URL } from "myconstants";

export function Error(): ReactElement {
  return (
    <main className="z-20 py-8 w-3/4 max-w-[800px] mx-auto">
      <div className="w-84 flex flex-row space-x-8 items-center justify-center mx-auto">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-20 w-20 text-red-500"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </svg>
        <p>
          Es ist ein unerwarteter Fehler aufgetreten. Versuchen Sie es bitte
          noch einmal, <br /> indem Sie die{" "}
          <Link to={URL.root} className="font-bold text-blue-400">
            Startseite
          </Link>{" "}
          aufrufen.
        </p>
      </div>
    </main>
  );
}
